module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n  Vous êtes maintenant déconnecté\n  "), _c('br'), _vm._v("\n  Vous allez être redirigé sur la page de connexion dans quelque secondes\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9125f23c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login-form/Logout.vue
// module id = 715
// module chunks = 1